import { Fragment, useState, useEffect } from "react";
///////
import MockTestInstructionView from "./mockTestInstructionView/mockTestInstructionView";
import MockTestQuestionView from "./mockTestQuestionView/mockTestQuestionView";
import mockActions from "../../../../../../redux/mock_test_exercise/action";
import {
  url_29,
  url_80,
  url_81,
  url_39,
  url_82,
  url_77,
  url_142,
} from "../../../../../../custom_utilities/api_services";
import axios from "axios";
import { isEmpty } from "../../../../../../custom_utilities/custom_useful_functions";

//Redux
import { connect } from "react-redux";
import uiActions from "../../../../../../redux/ui/action";

const MockTestContentComponent = (props) => {
  let {
    history,
    testData,
    setMockTestsResultData,
    userPreference,
    startLoading,
    finishLoading,
    userData,
  } = props;
  const [state, setState] = useState({
    step: 1,
    testDetails: {},
    testSectionsDetails: {},

    testQuestionsDetails: [],
    currentQuestionDetails: {},
    subjecSectiontWiseTestQuestions: {},
    checkQuestion: {},
    currentQuestion: 0,
    countDownTimer: {
      hours: 3,
      minutes: 0,
      seconds: 0,
    },
    initialTime: 0,
    useTime: 0,
  });
  const [selectedSubject, setSubject] = useState("");
  const [selectedSection, setSection] = useState("");

  const handleSubjectChange = (subject) => {
    const section = Object.keys(
      state.subjecSectiontWiseTestQuestions[subject]
    )[0];
    setSubject(subject);
    setSection(section);
    const currentQuestion =
      state.subjecSectiontWiseTestQuestions[subject][section][0]["matchIndex"];
    setState((prevState) => ({
      ...prevState,
      currentQuestion,
    }));

    const { testQuestionsDetails } = state;
    let cq = currentQuestion;
    getCurrentQuestionDetails(
      testQuestionsDetails[cq].paper_id,
      testQuestionsDetails[cq].qid
    );

    scrollUp(currentQuestion);

    //setSubject(subject);
  };

  const handleSectionChange = (section) => {
    setSection(section);
    const currentQuestion =
      state.subjecSectiontWiseTestQuestions[selectedSubject][section][0][
        "matchIndex"
      ];
    setState((prevState) => ({
      ...prevState,
      currentQuestion,
    }));

    const { testQuestionsDetails } = state;
    let cq = currentQuestion;
    getCurrentQuestionDetails(
      testQuestionsDetails[cq].paper_id,
      testQuestionsDetails[cq].qid
    );

    scrollUp(currentQuestion);
  };

  useEffect(() => {
    if (state.testQuestionsDetails.length) {
      setSubject(state.testQuestionsDetails[state.currentQuestion]["subject"]);
      setSection(
        state.testQuestionsDetails[state.currentQuestion]["section_name"]
      );
    }
  }, [state.currentQuestion, state.testQuestionsDetails]);

  useEffect(() => {
    getTestDetails();
    getTestSectionsDetails();
  }, []);

  useEffect(() => {
    if (state.step === 2) {
      createCountDownTimer(state.testDetails.duration_mins);
    }
    return () => {
      clearInterval(timeInterval);
    };
  }, [state.step]);

  let timeInterval;
  const createCountDownTimer = (duration) => {
    let useTime = state.useTime ?? 0;
    useTime = useTime * 1000;

    //duration is in minutes, first convert it to milliseconds
    let countdownTime = duration * 60 * 1000 + new Date().getTime();
    countdownTime = countdownTime - useTime;

    timeInterval = setInterval(() => {
      let now = new Date().getTime();
      let distance = countdownTime - now;
      if (distance < 0) {
        clearInterval(timeInterval);
        //hidemyend    //handleSubmitTest();
      }
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 60)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setState((prevState) => ({
        ...prevState,
        countDownTimer: {
          ...prevState.countDownTimer,
          hours,
          minutes,
          seconds,
        },
      }));
    }, 1000);
  };

  const getTestDetails = () => {
    setState((prevState) => ({ ...prevState, testDetails: testData }));
  };

  const getTestSectionsDetails = async () => {
    let data = {
      paper_id: testData.paper_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_29, data);
      if (response.data.status === 200) {
        setState((prevState) => ({
          ...prevState,
          testSectionsDetails: response.data.data,
        }));
        finishLoading();
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const getTestQuestionsList = async (testDetails) => {
    let data = {
      paper_id: testDetails.paper_id,
    };
    startLoading();
    try {
      const response = await axios.post(url_80, data);
      if (response.data.status === 200) {
        finishLoading();
        return {
          result: 1,
          data: { apiData: response.data },
        };
      } else {
        finishLoading();
        return {
          result: 0,
          data: { apiData: {} },
        };
      }
    } catch (error) {
      console.log(error);
      finishLoading();
      return {
        result: 0,
        data: { apiData: {} },
      };
    }
  };

  const getCurrentQuestionDetails = async (paper_id, qid) => {
    // const headers = {
    //   Authorization: `${tokenType} ${token}`,
    // };

    const data = {
      paper_id,
      qid,
    };
    startLoading();

    try {
      const response = await axios.post(url_142, data);

      if (response.data.status === 200) {
        finishLoading();
        setState((prevState) => ({
          ...prevState,
          currentQuestionDetails: response.data.data[0],
        }));
      }
    } catch (error) {
      finishLoading();
      console.log(error);
    }
  };

  const subjectWiseData = (questions) => {
    const subjectSectionWiseData = {};
    for (let i = 0; i < questions.length; i++) {
      questions[i]["matchIndex"] = i;
      if (!subjectSectionWiseData[questions[i]["subject"]]) {
        subjectSectionWiseData[questions[i]["subject"]] = {
          [questions[i]["section_name"]]: [questions[i]],
        };
      } else if (
        subjectSectionWiseData[questions[i]["subject"]] &&
        !subjectSectionWiseData[questions[i]["subject"]][
          questions[i]["section_name"]
        ]
      ) {
        subjectSectionWiseData[questions[i]["subject"]][
          questions[i]["section_name"]
        ] = [questions[i]];
      } else {
        subjectSectionWiseData[questions[i]["subject"]][
          questions[i]["section_name"]
        ].push(questions[i]);
      }
    }
    return subjectSectionWiseData;
  };

  const getNowTime = () => {
    let d = new Date();
    return d.getTime();
  };
  //exitTimeCurrentOption
  const startBtn = async () => {
    let testSectionsDetails = { ...state.testSectionsDetails };
    let testDetails = { ...state.testDetails };
    if (!isEmpty(testSectionsDetails) && !isEmpty(testDetails)) {
      let returnedResponse = await getTestQuestionsList(testDetails);
      const _subjecSectiontWiseTestQuestions = subjectWiseData(
        returnedResponse.data.apiData.data
      );
      if (returnedResponse.result) {
        getCurrentQuestionDetails(
          returnedResponse.data.apiData.data[0].paper_id,
          returnedResponse.data.apiData.data[0].qid
        );
        returnedResponse.data.apiData.data.forEach((element) => {
          element.isReview = false;
          element.isAttempted = false;
          element.isAnswerGuessed = false;
          element.totalTimeTaken = 0;
          element.isAnswerCorrect = 0;
          element.correctAnswerIdCollection = [];
          element.wrongAnswerIdCollection = [];
          element.userAnswerCollection = [];
          element.q_text = element.q_text
            .replaceAll(
              'src="ckfinder',
              'src="http://quizmaster.motion.ac.in/ckfinder'
            )
            .replaceAll(
              'SRC="ckfinder',
              'SRC="http://quizmaster.motion.ac.in/ckfinder'
            )
            .replaceAll(
              'src="/ckfinder',
              'src="http://quizmaster.motion.ac.in/ckfinder'
            )
            .replaceAll(
              'SRC="/ckfinder',
              'SRC="http://quizmaster.motion.ac.in/ckfinder'
            )
            .replaceAll(
              'SRC="ckfinder',
              'SRC="http://quizmaster.motion.ac.in/ckfinder'
            )
            .replaceAll(
              'SRC="./ckfinder',
              'SRC="http://quizmaster.motion.ac.in/ckfinder'
            )
            .replaceAll(
              'SRC= "ckfinder',
              'SRC="http://quizmaster.motion.ac.in/ckfinder'
            );
          element.option?.forEach((opt) => {
            opt.option = opt.option
              .replaceAll(
                'src="ckfinder',
                'src="http://quizmaster.motion.ac.in/ckfinder'
              )
              .replaceAll(
                'SRC="ckfinder',
                'SRC="http://quizmaster.motion.ac.in/ckfinder'
              )
              .replaceAll(
                'src="/ckfinder',
                'src="http://quizmaster.motion.ac.in/ckfinder'
              )
              .replaceAll(
                'SRC="/ckfinder',
                'SRC="http://quizmaster.motion.ac.in/ckfinder'
              )
              .replaceAll(
                'SRC="ckfinder',
                'SRC="http://quizmaster.motion.ac.in/ckfinder'
              )
              .replaceAll(
                'SRC="./ckfinder',
                'SRC="http://quizmaster.motion.ac.in/ckfinder'
              )
              .replaceAll(
                'SRC= "ckfinder',
                'SRC="http://quizmaster.motion.ac.in/ckfinder'
              );
          });
        });
        let time = getNowTime();
        setState((prevState) => ({
          ...prevState,
          step: 2,
          testQuestionsDetails: returnedResponse.data.apiData.data,
          subjecSectiontWiseTestQuestions: _subjecSectiontWiseTestQuestions,
          initialTime: time,
          useTime: returnedResponse.data.apiData.total_time,
        }));
        //handleQuestionJump(lastOption);
      } else {
        alert("No test questions found");
      }
    } else {
      alert("You don't have Test Details");
    }
  };

  const getCalculatedTime = (initialTime) => {
    let d = new Date();
    let time = d.getTime();

    let calculatedTime = Math.round((time - initialTime) / 1000);

    return calculatedTime;
  };
  const handlePreviousQuestionBtn = (cq) => {
    let { currentQuestion, initialTime, testQuestionsDetails } = state;
    let calculatedTime = getCalculatedTime(initialTime);

    testQuestionsDetails[currentQuestion].totalTimeTaken = calculatedTime;
    let time = getNowTime();
    if (currentQuestion >= 1) {
      setState((prevState) => ({
        ...prevState,
        currentQuestion: currentQuestion - 1,
        testQuestionsDetails: testQuestionsDetails,
        initialTime: time,
      }));

      handleSaveQuestion();

      window.scrollTo(0, 0);
      getCurrentQuestionDetails(
        testQuestionsDetails[cq].paper_id,
        testQuestionsDetails[cq].qid
      );
    }
  };

  const scrollUp = (currentQuestion) => {
    var element = document.getElementsByClassName(
      "questions_serial_number_collection"
    )[0];
    element.scrollTo({
      top: `${(currentQuestion + 1) * 80}`,
      behavior: "smooth",
    });
  };

  //save prticular question

  // const handleSaveQuestion = async () => {
  //   let { currentQuestion, initialTime, testQuestionsDetails, testDetails } =
  //     state;
  //   let crntQuestionDetail = testQuestionsDetails[currentQuestion];
  //   let formatData =
  //     testDetails.format ===
  //     "MAIN PATTERN TEST  [20 SINGLE, 10 NUMERIC] EACH SUBJECT"
  //       ? "MAIN"
  //       : testDetails.format === "NEET NEW PATTERN 2021 OTS"
  //       ? "NEET"
  //       : "OTHER";

  //   let data = {};

  //   if (crntQuestionDetail.answer_type == "Integer Correct") {
  //     data = {
  //       negative_marks: crntQuestionDetail.negative_marks,
  //       option_int: testQuestionsDetails[currentQuestion]?.integer_answer
  //         ?.length
  //         ? testQuestionsDetails[currentQuestion].integer_answer
  //         : "",
  //       paper_id: crntQuestionDetail.paper_id,
  //       partial_marks: crntQuestionDetail.partial_marks,
  //       positive_marks: crntQuestionDetail.positive_marks,
  //       qid: crntQuestionDetail.qid,
  //       subject: crntQuestionDetail.subject,
  //       time: crntQuestionDetail.totalTimeTaken,
  //       topic_name: crntQuestionDetail.topic_name,
  //       toughness: crntQuestionDetail.toughness,
  //       format: formatData,
  //       section: crntQuestionDetail.section_name,
  //     };
  //   } else {
  //     data = {
  //       negative_marks: Number(crntQuestionDetail.negative_marks),

  //       option_id: crntQuestionDetail.userAnswerCollection.length
  //         ? crntQuestionDetail.userAnswerCollection
  //         : [],
  //       paper_id: crntQuestionDetail.paper_id,
  //       partial_marks: Number(crntQuestionDetail.partial_marks),
  //       positive_marks: Number(crntQuestionDetail.positive_marks),
  //       qid: crntQuestionDetail.qid,
  //       subject: crntQuestionDetail.subject,
  //       time: crntQuestionDetail.totalTimeTaken,
  //       topic_name: crntQuestionDetail.topic_name,
  //       toughness: crntQuestionDetail.toughness,
  //       format: formatData,
  //       section: crntQuestionDetail.section_name,
  //     };
  //   }
  //   startLoading();
  //   const response = await axios.post(url_82, data);
  //   if (response.data.status === 200) {
  //     finishLoading();
  //   }
  // };

  const handleSaveQuestion = async () => {
    let { currentQuestion, initialTime, testQuestionsDetails, testDetails } =
      state;
    console.log("testQuestionsDetails tesing", testQuestionsDetails);

    let crntQuestionDetail = testQuestionsDetails[currentQuestion];
    console.log("crntQuestionDetail tesing", crntQuestionDetail);
    let formatData =
      testDetails.format ===
      "MAIN PATTERN TEST  [20 SINGLE, 10 NUMERIC] EACH SUBJECT"
        ? "MAIN"
        : testDetails.format === "NEET NEW PATTERN 2021 OTS"
        ? "NEET"
        : "OTHER";

    let data = {};

    if (crntQuestionDetail.answer_type == "Integer Correct") {
      data = {
        negative_marks: crntQuestionDetail.negative_marks,
        option_int: testQuestionsDetails[currentQuestion]?.integer_answer
          ?.length
          ? testQuestionsDetails[currentQuestion].integer_answer
          : "",
        paper_id: crntQuestionDetail.paper_id,
        partial_marks: crntQuestionDetail.partial_marks,
        positive_marks: crntQuestionDetail.positive_marks,
        qid: crntQuestionDetail.qid,
        subject: crntQuestionDetail.subject,
        time: crntQuestionDetail.totalTimeTaken,
        topic_name: crntQuestionDetail.topic_name,
        toughness: crntQuestionDetail.toughness,
        format: formatData,
        section: crntQuestionDetail.section_name,
      };
    } else if (crntQuestionDetail.answer_type == "Multiple Correct") {
      data = {
        negative_marks: Number(crntQuestionDetail.negative_marks),
        option_id: crntQuestionDetail?.userAnswerCollection?.length
          ? crntQuestionDetail.userAnswerCollection.map((item) => item)
          : [],
        paper_id: crntQuestionDetail.paper_id,
        partial_marks: Number(crntQuestionDetail.partial_marks),
        positive_marks: Number(crntQuestionDetail.positive_marks),
        qid: crntQuestionDetail.qid,
        subject: crntQuestionDetail.subject,
        time: crntQuestionDetail.totalTimeTaken,
        topic_name: crntQuestionDetail.topic_name,
        toughness: crntQuestionDetail.toughness,
        format: formatData,
        section: crntQuestionDetail.section_name,
      };
    } else {
      data = {
        negative_marks: Number(crntQuestionDetail.negative_marks),
        option_id: crntQuestionDetail?.userAnswerCollection?.length
          ? crntQuestionDetail.userAnswerCollection.map((item) => item)
          : [],
        paper_id: crntQuestionDetail.paper_id,
        partial_marks: Number(crntQuestionDetail.partial_marks),
        positive_marks: Number(crntQuestionDetail.positive_marks),
        qid: crntQuestionDetail.qid,
        subject: crntQuestionDetail.subject,
        time: crntQuestionDetail.totalTimeTaken,
        topic_name: crntQuestionDetail.topic_name,
        toughness: crntQuestionDetail.toughness,
        format: formatData,
        section: crntQuestionDetail.section_name,
      };
    }
    startLoading();
    const response = await axios.post(
      "https://learning.motion.ac.in/motioneducation/api/user/UserPYQDetailsNew",
      data
    );
    if (response.data.status === 200) {
      finishLoading();
    }
  };

  const handleNextQuestionBtn = (cq) => {
    let {
      currentQuestion,
      initialTime,
      testQuestionsDetails,
      currentQuestionDetails,
    } = state;
    let calculatedTime = getCalculatedTime(initialTime);
    testQuestionsDetails[currentQuestion].totalTimeTaken = calculatedTime;
    handleSaveQuestion();
    //newline add

    if (
      testQuestionsDetails[currentQuestion].isAttempted ||
      currentQuestionDetails?.option?.filter((m) => m.is_user_correct_ans)
        ?.length
    ) {
      testQuestionsDetails[currentQuestion].isReview = false;
    } else {
      testQuestionsDetails[currentQuestion].isReview = true;
    }
    let time = getNowTime();

    setState((prevState) => ({
      ...prevState,
      currentQuestion: currentQuestion + 1,
      testQuestionsDetails: testQuestionsDetails,
      initialTime: time,
    }));

    getCurrentQuestionDetails(
      testQuestionsDetails[cq].paper_id,
      testQuestionsDetails[cq].qid
    );

    window.scrollTo(0, 0);
  };

  const handleSingleSelectAnswer = (event, optionId) => {
    let { checked } = event.target;
    let { currentQuestion, testQuestionsDetails } = state;
    //localStorage.setItem("current", currentQuestion);
    if (checked) {
      testQuestionsDetails[currentQuestion].isAttempted = true;
      testQuestionsDetails[currentQuestion].userAnswerCollection[0] = optionId;

      if (
        testQuestionsDetails[currentQuestion].correctAnswerIdCollection.indexOf(
          optionId
        ) === -1
      ) {
        //if you not find the answer in backendCorrect answer array
        testQuestionsDetails[currentQuestion].wrongAnswerIdCollection[0] =
          optionId;
        testQuestionsDetails[currentQuestion].correctAnswerIdCollection = [];
        testQuestionsDetails[currentQuestion].isAnswerCorrect = 0;
      } else {
        testQuestionsDetails[currentQuestion].correctAnswerIdCollection[0] =
          optionId;
        testQuestionsDetails[currentQuestion].wrongAnswerIdCollection = [];
        testQuestionsDetails[currentQuestion].isAnswerCorrect = 1;
      }
    } else {
      testQuestionsDetails[currentQuestion].isAttempted = false;
      testQuestionsDetails[currentQuestion].userAnswerCollection = [];
      testQuestionsDetails[currentQuestion].wrongAnswerIdCollection = [];
      testQuestionsDetails[currentQuestion].correctAnswerIdCollection = [];
      testQuestionsDetails[currentQuestion].isAnswerCorrect = 0;
    }

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const handleMultiSelectAnswer = (_event, optionId) => {
    let { currentQuestion, testQuestionsDetails } = state;

    let findedIndex = testQuestionsDetails[
      currentQuestion
    ].userAnswerCollection.findIndex((element) => {
      return element === optionId;
    });

    if (findedIndex === -1) {
      testQuestionsDetails[currentQuestion].userAnswerCollection.splice(
        testQuestionsDetails[currentQuestion].userAnswerCollection.length,
        0,
        optionId
      );
    } else {
      testQuestionsDetails[currentQuestion].userAnswerCollection.splice(
        findedIndex,
        1
      );
    }

    if (testQuestionsDetails[currentQuestion].userAnswerCollection.length) {
      testQuestionsDetails[currentQuestion].isAttempted = true;
    } else {
      testQuestionsDetails[currentQuestion].isAttempted = false;
    }

    if (testQuestionsDetails[currentQuestion].wrongAnswerIdCollection.length) {
      testQuestionsDetails[currentQuestion].isAnswerCorrect = false;
    }

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const handleInputFieldChange = (event) => {
    let { value } = event.target;
    // value = value.replace(/[^0-9]/g, "")
    let { currentQuestion, testQuestionsDetails } = state;
    testQuestionsDetails[currentQuestion].integer_answer = value.trim();

    if (testQuestionsDetails[currentQuestion].integer_answer.length) {
      testQuestionsDetails[currentQuestion].isAttempted = true;
    } else {
      testQuestionsDetails[currentQuestion].isAttempted = false;
    }

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const reviewQuestion = async (currentQuestion) => {
    const { paper_id, qid, isAnswerGuessed } = currentQuestion;
    let data = {
      paper_id: paper_id,
      reference_id: qid,
      status: isAnswerGuessed ? 1 : 0,
      type: 3,
    };
    const response = await axios.post(url_77, data);
  };

  const handleReview = () => {
    let { currentQuestion, testQuestionsDetails } = state;

    testQuestionsDetails[currentQuestion].isAnswerGuessed =
      !testQuestionsDetails[currentQuestion].isAnswerGuessed;

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
    reviewQuestion(testQuestionsDetails[currentQuestion]);
  };

  const handleGuessedAnswer = (event) => {
    let { checked } = event.target;
    let { currentQuestion, testQuestionsDetails } = state;

    testQuestionsDetails[currentQuestion].isAnswerGuessed = checked;

    setState((prevState) => ({ ...prevState, testQuestionsDetails }));
  };

  const handleQuestionJump = (questionNumber) => {
    const { testQuestionsDetails } = state;
    //handleSaveQuestion();
    setState((prevState) => ({
      ...prevState,
      currentQuestion: questionNumber,
      // currentQuestion:0,
    }));

    getCurrentQuestionDetails(
      testQuestionsDetails[questionNumber].paper_id,
      testQuestionsDetails[questionNumber].qid
    );
  };

  // const handleSubmitTest = async (currentQuestionDetails) => {
  //   let { testDetails, testQuestionsDetails } = state;

  //   let element = currentQuestionDetails;

  //   let questionArr = [];

  //   if (element.answer_type.toLowerCase() === "single correct") {
  //     let data = {
  //       qid: element.qid,
  //       type_id: element.type_id,
  //       is_saved: element.is_saved,
  //       total_time: element.totalTimeTaken,
  //       is_attempted: element.isAttempted,
  //       is_AnswerCorrect: element.isAnswerCorrect,
  //       is_GessTypeAnswer: element.isAnswerGuessed,
  //       paragraph_answer: element.paragraph_answer,
  //       integer_answer: element.integer_answer,
  //       positive_marks: element.positive_marks,
  //       negative_marks: element.negative_marks,
  //       partial_marks: element.partial_marks,
  //       CorrectAnswerId: element.correctAnswerIdCollection,
  //       WrongeAnswerId: element.wrongAnswerIdCollection,
  //       answer: element.userAnswerCollection,
  //       toughness_id: element.toughness_id,
  //       subject: element.subject,
  //       topic_id: element.topic_id,
  //     };
  //     if (!data.type_id) {
  //       data.type_id = 6;
  //     }
  //     questionArr.push(data);
  //   } else if (element.answer_type.toLowerCase() === "multiple correct") {
  //     let data = {
  //       qid: element.qid,
  //       type_id: element.type_id,
  //       is_saved: element.is_saved,
  //       total_time: element.totalTimeTaken,
  //       is_attempted: element.isAttempted,
  //       is_AnswerCorrect: element.isAnswerCorrect,
  //       is_GessTypeAnswer: element.isAnswerGuessed,
  //       paragraph_answer: element.paragraph_answer,
  //       integer_answer: element.integer_answer,
  //       positive_marks: element.positive_marks,
  //       negative_marks: element.negative_marks,
  //       partial_marks: element.partial_marks,
  //       CorrectAnswerId: element.correctAnswerIdCollection,
  //       WrongeAnswerId: element.wrongAnswerIdCollection,
  //       answer: element.userAnswerCollection,
  //       toughness_id: element.toughness_id,
  //       subject: element.subject,
  //       topic_id: element.topic_id,
  //     };
  //     if (!data.type_id) {
  //       data.type_id = 6;
  //     }
  //     questionArr.push(data);
  //   } else if (element.answer_type.toLowerCase() === "integer correct") {
  //     let data = {
  //       qid: element.qid,
  //       type_id: element.type_id,
  //       is_saved: element.is_saved,
  //       total_time: element.totalTimeTaken,
  //       is_attempted: element.isAttempted,
  //       paragraph_answer: element.paragraph_answer,
  //       integer_answer: element.integer_answer,
  //       is_AnswerCorrect: element.isAnswerCorrect,
  //       is_GessTypeAnswer: element.isAnswerGuessed,
  //       positive_marks: element.positive_marks,
  //       negative_marks: element.negative_marks,
  //       partial_marks: element.partial_marks,
  //       CorrectAnswerId: element.correctAnswerIdCollection,
  //       WrongeAnswerId: element.wrongAnswerIdCollection,
  //       answer: element.userAnswerCollection,
  //       toughness_id: element.toughness_id,
  //       subject: element.subject,
  //       topic_id: element.topic_id,
  //     };
  //     if (!data.type_id) {
  //       data.type_id = 6;
  //     }
  //     questionArr.push(data);
  //   }
  //   startLoading();
  //   let returnedResponse = await submitTestApi(
  //     userPreference,
  //     testDetails,
  //     questionArr
  //   );
  //   if (returnedResponse.result) {
  //     finishLoading();
  //     setMockTestsResultData(testDetails);

  //     history.push({
  //       pathname: "/mock_test_summary",
  //     });
  //   } else {
  //     finishLoading();
  //     alert(returnedResponse.data.message);
  //     // history.push("/user_exercise_test");
  //   }
  // };

  const handleSubmitTest = async (currentQuestionDetails) => {
    let { testDetails, testQuestionsDetails } = state;

    let element = currentQuestionDetails;

    let questionArr = [];

    if (element.answer_type.toLowerCase() === "single correct") {
      let data = {
        qid: element.qid,
        type_id: element.type_id,
        is_saved: element.is_saved,
        total_time: element.totalTimeTaken,
        is_attempted: element.isAttempted,
        is_AnswerCorrect: element.isAnswerCorrect,
        is_GessTypeAnswer: element.isAnswerGuessed,
        paragraph_answer: element.paragraph_answer,
        integer_answer: element.integer_answer,
        positive_marks: element.positive_marks,
        negative_marks: element.negative_marks,
        partial_marks: element.partial_marks,
        CorrectAnswerId: element.correctAnswerIdCollection,
        WrongeAnswerId: element.wrongAnswerIdCollection,
        answer: element.userAnswerCollection,
        toughness_id: element.toughness_id,
        subject: element.subject,
        topic_id: element.topic_id,
      };
      if (!data.type_id) {
        data.type_id = 6;
      }
      questionArr.push(data);
    } else if (element.answer_type.toLowerCase() === "multiple correct") {
      let data = {
        qid: element.qid,
        type_id: element.type_id,
        is_saved: element.is_saved,
        total_time: element.totalTimeTaken,
        is_attempted: element.isAttempted,
        is_AnswerCorrect: element.isAnswerCorrect,
        is_GessTypeAnswer: element.isAnswerGuessed,
        paragraph_answer: element.paragraph_answer,
        integer_answer: element.integer_answer,
        positive_marks: element.positive_marks,
        negative_marks: element.negative_marks,
        partial_marks: element.partial_marks,
        CorrectAnswerId: element.correctAnswerIdCollection,
        WrongeAnswerId: element.wrongAnswerIdCollection,
        answer: element.userAnswerCollection,
        toughness_id: element.toughness_id,
        subject: element.subject,
        topic_id: element.topic_id,
      };
      if (!data.type_id) {
        data.type_id = 6;
      }
      questionArr.push(data);
    } else if (element.answer_type.toLowerCase() === "integer correct") {
      let data = {
        qid: element.qid,
        type_id: element.type_id,
        is_saved: element.is_saved,
        total_time: element.totalTimeTaken,
        is_attempted: element.isAttempted,
        paragraph_answer: element.paragraph_answer,
        integer_answer: element.integer_answer,
        is_AnswerCorrect: element.isAnswerCorrect,
        is_GessTypeAnswer: element.isAnswerGuessed,
        positive_marks: element.positive_marks,
        negative_marks: element.negative_marks,
        partial_marks: element.partial_marks,
        CorrectAnswerId: element.correctAnswerIdCollection,
        WrongeAnswerId: element.wrongAnswerIdCollection,
        answer: element.userAnswerCollection,
        toughness_id: element.toughness_id,
        subject: element.subject,
        topic_id: element.topic_id,
      };
      if (!data.type_id) {
        data.type_id = 6;
      }
      questionArr.push(data);
    }
    startLoading();
    let returnedResponse = await submitTestApi(
      userPreference,
      testDetails,
      questionArr
    );
    if (returnedResponse.result) {
      finishLoading();
      setMockTestsResultData(testDetails);
      history.push({
        pathname: "/mock_test_summary",
      });
    } else {
      finishLoading();
      alert(returnedResponse.data.message);
      // history.push("/user_exercise_test");
    }
  };

  const submitTestApi = async (_userPreference, testDetails, _questionArr) => {
    let requestPayload = {
      paper_id: testDetails.paper_id,
      // time: state.countDownTimer?.minutes,
      time: 84,
    };

    try {
      const response = await axios.post(url_81, requestPayload);
      if (response.data.status === 200) {
        return {
          result: 1,
          data: {
            message: response.data.message,
          },
        };
      } else {
        return {
          result: 0,
          data: {
            message: response.data.message,
          },
        };
      }
    } catch (error) {
      console.log(error);
      return {
        result: 0,
        data: {
          message: "Something went wrong!!!",
        },
      };
    }
  };

  const renderView = (step) => {
    switch (step) {
      case 1:
        return (
          <MockTestInstructionView
            testDetails={state.testDetails}
            testSectionsDetails={state.testSectionsDetails}
            startBtn={startBtn}
          />
        );
      case 2:
        return (
          <MockTestQuestionView
            testQuestionsDetails={state.testQuestionsDetails}
            subjecSectiontWiseTestQuestions={
              state.subjecSectiontWiseTestQuestions
            }
            selectedSubject={selectedSubject}
            selectedSection={selectedSection}
            handleSubjectChange={handleSubjectChange}
            handleSectionChange={handleSectionChange}
            currentQuestion={state.currentQuestion}
            countDownTimer={state.countDownTimer}
            handlePreviousQuestionBtn={handlePreviousQuestionBtn}
            handleNextQuestionBtn={handleNextQuestionBtn}
            handleSaveQuestion={handleSaveQuestion}
            handleSingleSelectAnswer={handleSingleSelectAnswer}
            handleMultiSelectAnswer={handleMultiSelectAnswer}
            handleInputFieldChange={handleInputFieldChange}
            handleReview={handleReview}
            handleGuessedAnswer={handleGuessedAnswer}
            handleQuestionJump={handleQuestionJump}
            handleSubmitTest={handleSubmitTest}
            checkQuestion={state.checkQuestion}
            userId={userData.user_id}
            startLoading={startLoading}
            finishLoading={finishLoading}
            currentQuestionDetails={state.currentQuestionDetails}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Fragment>
      <div className="Pyq_test_content_component_wrapper">
        <div className="test_content_component_inner_wrapper">
          {renderView(state.step)}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    testData: state.mockTestsData.mockTestData,
    userPreference: state.userPreference,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setMockTestsResultData: (payload) => {
      dispatch(mockActions.setMockTestsResultData(payload));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MockTestContentComponent);
